// Workout template hooks.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk, templatesApi } from "../api";
import type { TemplateInput } from "../api";

export function useTemplates() {
  return useQuery({
    queryKey: qk.templates.root,
    queryFn: ({ signal }) => templatesApi.list(signal),
  });
}

export function useTemplate(id: number | undefined) {
  return useQuery({
    queryKey: qk.templates.detail(id ?? -1),
    queryFn: ({ signal }) => templatesApi.get(id as number, signal),
    enabled: id !== undefined && id >= 0,
  });
}

export function useCreateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: TemplateInput) => templatesApi.create(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: qk.templates.root });
    },
  });
}

export function useUpdateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: TemplateInput }) =>
      templatesApi.update(id, body),
    onSuccess: (_t, { id }) => {
      void qc.invalidateQueries({ queryKey: qk.templates.detail(id) });
      void qc.invalidateQueries({ queryKey: qk.templates.root });
    },
  });
}

export function useDeleteTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => templatesApi.remove(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: qk.templates.root });
    },
  });
}
